import Vue from "vue";
import Meta from "vue-meta";
import VueMq from "vue-mq";
import VueAWN from "vue-awesome-notifications";
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import App from "./App.vue";
import Mobile from "./App.mobile.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";

import "whatwg-fetch";
import "abort-controller/polyfill";
import "./registerServiceWorker";
import "./bootstrap";

const platformCss = require("!!raw-loader!sass-loader!./assets/styles/app.scss");
const mobileCss = require("!!raw-loader!sass-loader!./assets/styles/app.mobile.scss");

const isMobile = () => {
  return window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
};

if (location.pathname.match(/^\/$/) && isMobile()) {
  new Vue({
    store,
    i18n,
    render: h => h(Mobile),
    mounted() {
      //width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0
      const meta = document.getElementsByName("viewport");
      if (meta.length) {
        // @ts-ignore
        meta[0].content =
          "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
      }
      const style = document.createElement("style");
      style.innerHTML = mobileCss.default;
      document.head.appendChild(style);
      // You'll need this for renderAfterDocumentEvent.
      document.dispatchEvent(new Event("render-event"));
    }
  }).$mount("#app");
} else {
  Vue.use(Meta);
  Vue.use(VueMq, {
    breakpoints: { xs: 360, sm: 450, md: 960, lg: 1440, xl: Infinity }
  });
  Vue.use(VueAWN, {
    durations: { info: 0 }
  });

  library.add(faInfoCircle);
  Vue.component("font-awesome-icon", FontAwesomeIcon);
  dom.watch();

  Vue.config.productionTip = false;

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    mounted() {
      const style = document.createElement("style");
      style.innerHTML = platformCss.default;
      document.head.appendChild(style);
      // You'll need this for renderAfterDocumentEvent.
      document.dispatchEvent(new Event("render-event"));
    }
  }).$mount("#app");
}
